exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home {\n  background-image: url(\"https://res.cloudinary.com/eclimontessori/image/upload/v1572006261/IMG_2082_qsnvgm.jpg\"); }\n\niframe#video {\n  margin: 20px auto;\n  max-width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./app/pages/index/css/index.scss
// module id = 16
// module chunks = 4